var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exec-report-panel',{attrs:{"report-name":"delivery-ops","title":"Operación y entregas","filters":_vm.filters},on:{"error":function($event){return _vm.$emit('error', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }